import React, { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Alert from '@mui/material/Alert'
import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import API from '../../component/Axios'
import { normalizeAnimalPackageCode } from './animalPackageUtils'

export default function AnimalPackageSharingFields({ data, setData, currentProductId }) {
    const history = useHistory()
    const [packages, setPackages] = useState([])
    const [loading, setLoading] = useState(true)
    const [errorMessage, setErrorMessage] = useState('')

    useEffect(() => {
        let mounted = true

        const loadPackages = async () => {
            try {
                const { data: response } = await API.post('/api/v1/admin/animalPackage/getList', {
                    page: 1,
                    offset: 1000,
                    searchText: '',
                    searchSelect: { status: 1 },
                })

                if (!mounted) {
                    return
                }

                if ([1, 200].includes(Number(response.code))) {
                    setPackages(response.data?.rows || [])
                    setErrorMessage('')
                } else if (Number(response.code) === 403) {
                    history.push('/login')
                } else {
                    setErrorMessage(response.message || '진행도 공유 기준을 불러오지 못했습니다.')
                }
            } catch (_error) {
                if (mounted) {
                    setErrorMessage('진행도 공유 기준을 불러오지 못했습니다.')
                }
            } finally {
                if (mounted) {
                    setLoading(false)
                }
            }
        }

        loadPackages()

        return () => {
            mounted = false
        }
    }, [history])

    const progressPackageChoices = useMemo(() => packages.filter((item) => (
        !item.progressAnimalPackageId && Number(item.productId) !== Number(currentProductId)
    )), [currentProductId, packages])
    const progressPackageCode = data.progressPackageCode || ''
    const hasSelectedPackage = progressPackageChoices.some((item) => item.packageCode === progressPackageCode)

    const updateField = (field, value) => {
        setData((prev) => ({
            ...prev,
            [field]: value,
        }))
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    required
                    size="small"
                    label="고유 패키지 코드"
                    value={data.packageCode || ''}
                    onChange={(event) => updateField('packageCode', event.target.value.toUpperCase())}
                    onBlur={(event) => updateField('packageCode', normalizeAnimalPackageCode(event.target.value))}
                    inputProps={{ maxLength: 50 }}
                    helperText="판매 상품을 구분하는 고유 코드입니다. 영문 대문자, 숫자, 밑줄만 사용할 수 있습니다."
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField
                    fullWidth
                    select
                    size="small"
                    label="진행도 공유 기준"
                    value={progressPackageCode}
                    onChange={(event) => updateField('progressPackageCode', event.target.value)}
                    disabled={loading}
                    helperText="선택하면 활성화 여부와 메달 진행도를 기준 패키지와 공유합니다. 가격과 재고는 현재 상품 기준입니다."
                >
                    <MenuItem value="">공유하지 않음 (자체 진행도)</MenuItem>
                    {!hasSelectedPackage && progressPackageCode && (
                        <MenuItem value={progressPackageCode}>{progressPackageCode} · 현재 설정</MenuItem>
                    )}
                    {progressPackageChoices.map((item) => (
                        <MenuItem key={item.animalPackageId} value={item.packageCode}>
                            {item.packageCode} · {item.product?.title || '상품명 없음'}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            {errorMessage && (
                <Grid item xs={12}>
                    <Alert severity="warning">{errorMessage} 직접 입력한 내용은 유지되지만 진행도 공유 기준을 선택할 수 없습니다.</Alert>
                </Grid>
            )}
        </Grid>
    )
}
